var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCopy = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 22.857,
    viewBox: "0 0 20 22.857",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "copy",
    d: "M17.143,15.714H10a1.427,1.427,0,0,1-1.429-1.429V2.857A1.427,1.427,0,0,1,10,1.429h4.826a.717.717,0,0,1,.5.21L18.362,4.67a.717.717,0,0,1,.21.5v9.112A1.427,1.427,0,0,1,17.143,15.714ZM19.371,3.656,16.344.629A2.143,2.143,0,0,0,14.83,0H10A2.86,2.86,0,0,0,7.143,2.857V14.286A2.86,2.86,0,0,0,10,17.143h7.143A2.86,2.86,0,0,0,20,14.286V5.174a2.143,2.143,0,0,0-.629-1.513ZM2.857,5.714A2.86,2.86,0,0,0,0,8.571V20a2.86,2.86,0,0,0,2.857,2.857H10A2.86,2.86,0,0,0,12.857,20V18.571H11.429V20A1.427,1.427,0,0,1,10,21.429H2.857A1.427,1.427,0,0,1,1.429,20V8.571A1.427,1.427,0,0,1,2.857,7.143H5.714V5.714Z",
    fill: "#737373"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCopy);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/copy.70f5b2d22abe9dd0447d57064538b3c7.svg";